import { useContext } from 'react';
import type { SpLogicLoadDocumentApi } from '@sp-api/load-document-api';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function useLoadDocumentApiClient(): SpLogicLoadDocumentApi {
  const { loadDocumentApi } = useContext(ApiContext);

  return loadDocumentApi;
}
